import React from 'react'
import { Title } from '../HeroSection/HeroStyle'
import { Container, Desc, TimelineSection, Wrapper } from './ExperienceStye'
import { experiences } from '../../data/constants'

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import ExperienceCard from '../Cards/ExperienceCard';
function Experience() {
  return (
    <Container id='experience'>
        <Wrapper>
            <Title>Experience</Title>
            <Desc>My work experience as a Full Stack Developer and working on different companies and projects.</Desc>
            <TimelineSection>
                <Timeline>
                    {experiences.map((experience,index)=>
                    (
                        <TimelineItem>
                            <TimelineSeparator>
                                <TimelineDot variant='outlined' color='secondary'/>
                                {index !==experience.length - 1 && ( <TimelineConnector />)}
                               
                            </TimelineSeparator>
                            <TimelineContent sx={{py: '12px', px: 2}}>
                                <ExperienceCard experience={experience}/>
                            </TimelineContent>
                        </TimelineItem>
                    )
                    )}
                </Timeline>
            </TimelineSection>
        </Wrapper>
        
        </Container>
  )
}

export default Experience